export const CharacterImage = {
  buruk: require('./buruk.png'),
  'married-s': require('./married-s.png'),
  delay: require('./delay.png'),
  godok: require('./godok.png'),
  kongkong: require('./kongkong.png'),
  mulung: require('./mulung.png'),
  umgyuk: require('./umgyuk.png'),
  minder: require('./minder.png'),
} as Record<string, string>
